import React from 'react';
import { getJobActivityTaskStatusIcon } from 'ats/utils/jobApplicationTaskTheme';

const taskIcon = type => `/ats/icons/${type.replace(/_/g, '-')}-icon.svg`;

const theme = (
	className,
	type,
	accent,
	cardBg,
	cardBorder,
	tagBg = '#FFFFFF'
) => ({
	className,
	icon: taskIcon(type),
	accent,
	cardBg,
	cardBorder,
	tagBg
});

export const applicantTaskThemes = {
	hr_interview: theme(
		'is-hr-interview',
		'hr_interview',
		'#7A5AF8',
		'#F4F3FF',
		'#D9D6FE',
		'#FFFFFF'
	),
	test: theme('is-test', 'test', '#E31B54', '#FEF3F2', '#FECDCA', '#FFFFFF'),
	coding_challenge: theme(
		'is-coding-challenge',
		'coding_challenge',
		'#F79009',
		'#FFFAEB',
		'#FEF0C7',
		'#FFFFFF'
	),
	technical_interview: theme(
		'is-technical-interview',
		'technical_interview',
		'#6172F3',
		'#EEF4FF',
		'#C7D7FE',
		'#FFFFFF'
	),
	follow_up: theme(
		'is-follow-up',
		'follow_up',
		'#A4A7AE',
		'#F9FAFB',
		'#D5D7DA',
		'#FFFFFF'
	),
	profile_approval: theme(
		'is-profile-approval',
		'profile_approval',
		'#0EA688',
		'#ECFDF3',
		'#A7F3D0',
		'#FFFFFF'
	),
	note: theme('is-note', 'note', '#1D222B', '#FCFCFD', '#EAECF5', '#FFFFFF'),
	team_transfer: theme(
		'is-team-transfer',
		'team_transfer',
		'#717680',
		'#F9FAFB',
		'#D5D7DA',
		'#FFFFFF'
	)
};

const defaultTheme = applicantTaskThemes.note;

export const getApplicantTaskTheme = type =>
	applicantTaskThemes[type] || defaultTheme;

export { getJobActivityTaskStatusIcon as getApplicantTaskStatusIcon };

export const renderApplicantTaskTypeLabel = (label, type) => {
	const taskTheme = getApplicantTaskTheme(type);

	return (
		<span
			className="job-task-dropdown-option"
			style={{ color: taskTheme.accent }}>
			<img src={taskTheme.icon} alt="" />
			{label}
		</span>
	);
};

export const getApplicantTaskDropdownOptions = taskOptions =>
	taskOptions.map(task => {
		const taskTheme = getApplicantTaskTheme(task.value);

		return {
			...task,
			text: task.label,
			className: `job-task-dropdown-item ${taskTheme.className}`,
			label: renderApplicantTaskTypeLabel(task.label, task.value)
		};
	});
